export const SET_EVITE_EVENT = 'eviteEvent/set';

export const UPDATE_EVITE_EVENT = 'eviteEvent/update';
